import type {KeyboardEventHandler} from 'react';

const ARROW_DOWN_KEY = 'ArrowDown';

export const handleDropdownStickyRegionKeyDown: KeyboardEventHandler<HTMLDivElement> = (event) => {
  const isFocusedInside = event.currentTarget.contains(document.activeElement);
  const isNotArrowDownKey = event.key !== ARROW_DOWN_KEY;
  if (isFocusedInside && isNotArrowDownKey) {
    event.stopPropagation();
  }
};
